// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6b2f1513","371":"d3de832b","455":"cee161f9"}[chunkId] + ".chunk.js";
};